export const historyAndStateTypes = {
    VEHICLE_SELECT: 'HISTORY_AND_STATE_VEHICLE_SELECT',
    TOGGLE_STATE: 'HISTORY_AND_STATE_TOGGLE_STATE',
    CLEANUP: 'HISTORY_AND_STATE_CLEANUP',
};


